import React from 'react';
export default function TriangleGlasses() {
  return (
<><g transform="translate(0 -263.133)"><rect width="6.782" height="4.086" x="8.897" y="273.087" ry="2.043" fill="#d2d2d2" stroke="#4d4d4d" strokeWidth=".529"/><rect ry="2.043" y="273.067" x="18.541" height="4.086" width="6.782" fill="#d2d2d2" stroke="#4d4d4d" strokeWidth=".529"/><path d="M15.54 273.88v.862h3.158v-.862z" color="#000" overflow="visible" fill="#4d4d4d"/></g></>); }
